import { objectDuckCreator } from '@atc/modular-redux';

const interestRateDuck = objectDuckCreator({
    store: 'interestRates',
});

export default interestRateDuck;
